import React, { useEffect, useState } from "react";
import { Footprints } from "lucide-react";
import { api } from "../lib/api";

// Unobtrusive Studio Away / Shipping Pause notice. Renders only while active
// (auto-expires server-side on the resume date). Checkout stays enabled — this is a delay, not a closure.
export function ShippingNotice({ className = "" }) {
  const [away, setAway] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setAway(r.data.away)).catch(() => {});
  }, []);
  if (!away?.active) return null;
  return (
    <div className={`flex items-start gap-3 border-l-2 border-[#B35D4B] bg-[#F0EFEA] px-4 py-3 text-sm text-[#4A4947] ${className}`} data-testid="shipping-notice">
      <Footprints className="w-4 h-4 mt-0.5 shrink-0 text-[#B35D4B]" strokeWidth={1.5} />
      <p>{away.notice}</p>
    </div>
  );
}
